import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Home = () => {
  const features = [
    {
      title: '팟캐스트',
      description: 'NCS 이론을 음성으로 학습하세요',
      icon: '🎧',
      path: '/podcast',
      color: 'bg-blue-500'
    },
    {
      title: '요약정리',
      description: '학습모듈별 핵심 내용 요약',
      icon: '📚',
      path: '/summary',
      color: 'bg-indigo-500'
    },
    {
      title: '마인드맵',
      description: '최적의 학습경로를 시각화',
      icon: '🗺️',
      path: '/mindmap',
      color: 'bg-green-500'
    },
    {
      title: '객관식 퀴즈',
      description: '학습한 내용을 확인해보세요',
      icon: '📝',
      path: '/quiz',
      color: 'bg-purple-500'
    },
    {
      title: '파슨스 문제',
      description: '코드 순서를 맞춰보세요',
      icon: '🧩',
      path: '/parsons',
      color: 'bg-orange-500'
    },
    {
      title: 'AI 면접',
      description: 'AI와 모의 면접을 진행하세요',
      icon: '🤖',
      path: '/interview',
      color: 'bg-red-500'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl font-bold text-gray-800 mb-6">
            NCS 학습 도우미
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            NCS 기반 개발자 역량 향상을 위한 종합 학습 플랫폼
          </p>


        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              {feature.path === '/mindmap' ? (
                <a href={feature.path} target="_blank" rel="noopener noreferrer" className="block">
                  <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8 h-full">
                    <div className={`w-16 h-16 ${feature.color} rounded-full flex items-center justify-center text-2xl mb-6 mx-auto`}>
                      {feature.icon}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 text-center">
                      {feature.description}
                    </p>
                  </div>
                </a>
              ) : (
                <Link to={feature.path} className="block">
                  <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8 h-full">
                    <div className={`w-16 h-16 ${feature.color} rounded-full flex items-center justify-center text-2xl mb-6 mx-auto`}>
                      {feature.icon}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 text-center">
                      {feature.description}
                    </p>
                  </div>
                </Link>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;